// --------------------------
// ハンバーガーメニュー
// --------------------------
document.addEventListener("DOMContentLoaded", function () {
  const tabMenuItems = document.querySelectorAll(".tab__menu-item");
  const tabMenuFirstItems = document.querySelectorAll(".tab__menu--first .tab__menu-item");
  const tabPanels = document.querySelectorAll(".tab__panel-box");
  const tabWrap = document.querySelector(".tab-wrap");
  const drawerButton = document.getElementById("hamburger-button");
  const drawerNav = document.getElementById("hamburger-menu");
  const body = document.body;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function resetTabs() {
    tabMenuItems.forEach(item => item.classList.remove("is-active"));
    tabPanels.forEach(panel => panel.classList.remove("is-show"));

    // .tab__menu--first 内のタブは対象外にして、最初のタブを開く
    const firstTab = document.querySelector(".tab__menu:not(.tab__menu--first) .tab__menu-item[data-tab='01']");
    const firstPanel = document.querySelector(".tab__panel-box[data-panel='01']");

    if (firstTab && firstPanel) {
      firstTab.classList.add("is-active");
      firstPanel.classList.add("is-show");
    }
  }

  // ハンバーガーメニューの開閉処理
  drawerButton.addEventListener("click", function () {
    const isOpening = !drawerNav.classList.contains("is-active");

    drawerButton.classList.toggle("is-active");
    drawerNav.classList.toggle("is-active");
    body.classList.toggle("is-menu-active");

    if (!isOpening) {
      setTimeout(resetTabs, 300); // メニューが閉じた後にリセット
    }
  });

  function resetPanels() {
    if (isMobile()) {
      tabPanels.forEach(panel => panel.classList.remove("is-show"));
      tabMenuItems.forEach(item => item.classList.remove("is-active"));
    } else {
      resetTabs();
    }
  }

  // 初期設定
  resetPanels();

  tabMenuItems.forEach(item => {
    // .tab__menu--first 内のアイテムはスキップ
    if (item.closest(".tab__menu--first")) return;

    item.addEventListener("click", function (event) {
      event.stopPropagation();

      const targetPanel = document.querySelector(`.tab__panel-box[data-panel='${this.dataset.tab}']`);

      if (isMobile()) {
        if (targetPanel.classList.contains("is-show")) {
          targetPanel.classList.remove("is-show");
          this.classList.remove("is-active");
        } else {
          tabPanels.forEach(panel => panel.classList.remove("is-show"));
          tabMenuItems.forEach(item => item.classList.remove("is-active"));

          targetPanel.classList.add("is-show");
          this.classList.add("is-active");

          // スクロール処理
          setTimeout(() => {
            targetPanel.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 200);
        }
      } else {
        document.querySelector(".tab__menu-item.is-active")?.classList.remove("is-active");
        document.querySelector(".tab__panel-box.is-show")?.classList.remove("is-show");

        this.classList.add("is-active");
        targetPanel.classList.add("is-show");
      }
    });
  });

  // タブ以外 or `.tab__panel-box` をクリックしたらパネルを閉じる
  document.addEventListener("click", function (event) {
    if (isMobile()) {
      if (!tabWrap.contains(event.target) || event.target.closest(".tab__panel-box")) {
        tabPanels.forEach(panel => panel.classList.remove("is-show"));
        tabMenuItems.forEach(item => item.classList.remove("is-active"));
      }
    }
  });

  window.addEventListener("resize", resetPanels);
});


// --------------------------
// slick
// --------------------------
$(function () {
  // メインスライダー（フェード効果あり）
  $('.js-kv-slider').slick({
    fade: true,
    speed: 3000,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: '<div class="slick-prev"><img src="./assets/img/common/kv_arrow02.png" alt="prev"></div>',
    nextArrow: '<div class="slick-next"><img src="./assets/img/common/kv_arrow.png" alt="next"></div>',
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    asNavFor: ".js-kv-slider-02",
  });

  // サブスライダー（複数表示）
  $('.js-kv-slider-02').slick({
    fade: false,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    swipe: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: ".js-kv-slider",
    focusOnSelect: true,
    dotsClass: 'dots-wrap',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.3,
        },
      },
    ],
  });
});


// --------------------------
// グロナビタブ切り替え
// --------------------------
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".list-gnav-item");
  const tabs = document.querySelectorAll(".tab-box");

  buttons.forEach(button => {
    button.addEventListener("click", (event) => {
      event.stopPropagation(); // クリックイベントの伝播を防ぐ
      const tabId = button.getAttribute("data-tab");
      const targetTab = document.getElementById(tabId);
      const isActive = button.classList.contains("active");

      // すべてのボタンとタブのアクティブ状態を解除
      buttons.forEach(btn => btn.classList.remove("active"));
      tabs.forEach(tab => tab.classList.remove("active"));

      // クリックされたボタンがすでにアクティブなら閉じる、それ以外なら開く
      if (!isActive) {
        button.classList.add("active");
        targetTab.classList.add("active");
      }
    });
  });

  // メニュー外をクリックしたら閉じる
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".gnav-tab")) {
      buttons.forEach(btn => btn.classList.remove("active"));
      tabs.forEach(tab => tab.classList.remove("active"));
    }
  });
});


// --------------------------
// NEWSタブ切り替え
// --------------------------
document.querySelectorAll(".tab-button").forEach(button => {
  button.addEventListener("click", () => {
    const tabId = button.getAttribute("data-tab");

    // ボタンのアクティブ状態を更新
    document.querySelectorAll(".tab-button").forEach(btn => btn.classList.remove("active"));
    button.classList.add("active");

    // コンテンツの表示を切り替え
    document.querySelectorAll(".tab-content").forEach(content => content.classList.remove("active"));
    document.getElementById(tabId).classList.add("active");
  });
});


// -------------------------------
// ナビゲーション内フォーカス解除
// -------------------------------
document.querySelectorAll('.detail__item a').forEach((link) => {
  link.addEventListener('click', function () {
    this.blur();
  });
});


// -------------------------------------
// 別ページアンカーリンクの smooth scroll
// -------------------------------------
$(document).ready(function () {
  const $header = $('header');
  const headerHeight = $header.length ? $header.outerHeight() : 0;

  // 現在のURLのハッシュを取得し、スムーズスクロール
  const hash = window.location.hash;
  if (hash) {
    smoothScrollTo(hash);
  }

  // ページ内リンクをクリックしたときの処理
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault(); // デフォルトの動作を無効化

    const targetId = $(this).attr('href'); // クリックしたリンクのhref属性を取得
    smoothScrollTo(targetId);

    // URLのハッシュを更新（履歴に追加される）
    history.pushState(null, null, targetId);
  });

  // スムーズスクロール関数
  function smoothScrollTo(targetId) {
    const $targetElement = $(targetId);

    if ($targetElement.length) {
      const targetPosition = $targetElement.offset().top - headerHeight;

      $('html, body').animate(
        {
          scrollTop: targetPosition,
        },
        600, // スクロール速度（ミリ秒）
        'swing' // イージング（動きの緩急）
      );
    }
  }
});


// -------------------------------------
// 感染研フォーマット：サイドバー
// -------------------------------------
$(function () {
  const path = window.location.pathname;

  const submenuOpenPaths = [
    // 研究所の概要
    '/content/20250304120905.html',
    '/content/20250409182027.html',

    // 研究情報
    '/content2/20250324162728.html',
    '/content2/research_information/20250324174146.html',
    '/content2/research_information/20250324180050.html',
    '/content2/research_information/20250324180329.html',
    '/content2/research_information/20250324180501.html',
    '/content2/research_information/20250324180812.html',
    '/content2/research_information/20250324181105.html',
    '/content2/research_information/20250324195740.html',
    '/content2/research_information/20250324195948.html',
    '/content2/research_information/20250324200129.html',
    '/content2/research_information/20250324200310.html',
    '/content2/research_information/20250324200524.html',
    '/content2/research_information/20250324201507.html',
    '/content2/research_information/20250324201703.html',
    '/content2/research_information/20250324201836.html',

    // 公開講座・研修
    '/content9/20250327172847.html',
    '/content9/20250331201830.html',
    '/content9/20250312145039.html',
    '/content9/20250331201613.html',
    '/content9/20250319142345.html',
    '/content9/20250402184211.html',

    // 国際協力
    '/content2/international_cooperation/20250313171610.html',
    '/content2/international_cooperation/20250313172059.html',
    '/content2/international_cooperation/20250313172651.html',
    '/content2/international_cooperation/20250313173813.html',
    '/content2/international_cooperation/20250313174549.html',
    '/content2/international_cooperation/20250313175222.html',
    '/content2/international_cooperation/20250313175118.html',
  ];

  // パスに一致する場合、その親メニューを展開
  submenuOpenPaths.forEach(subPath => {
    if (path === subPath) {
      $('.aside-title.has-submenu').each(function () {
        if ($(this).find(`a[href="${subPath}"]`).length > 0 || $(this).find('ul.submenu a[href="' + path + '"]').length > 0) {
          $(this).addClass('open');
        }
      });
    }
  });
});



// -------------------------------------
// グロナビ　自動生成＋アンカーリンク付与
// -------------------------------------
// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(() => {
//     const parent = document.querySelector("#gnav-tab1 .tab-item dl");

//     if (!parent) {
//       return; // 親要素が見つからない場合は処理を終了
//     }

//     let listItems = parent.querySelectorAll("a");

//     if (listItems.length >= 6) {
//       const clone = listItems[5].cloneNode(true);
//       clone.href += "#anchor-logo";

//       // リンクテキストを「JIHSのロゴについて」に変更
//       clone.textContent = "JIHSのロゴについて";

//       listItems = parent.querySelectorAll("a"); // 最新のリストを取得

//       if (listItems.length >= 8) {
//         const target = parent.children[7]; // 8番目の要素を取得

//         if (target && parent.contains(target)) {
//           parent.insertBefore(clone, target);
//         } else {
//           parent.appendChild(clone);
//         }
//       } else {
//         parent.appendChild(clone);
//       }
//     }
//   }, 1000);
// });
